/**
 * External dependencies
 */
import { css } from '@emotion/react';

export const FormGroup = css`
	width: 100%;
`;
